const LOGO =
  "https://customer-assets.emergentagent.com/wingman/85cf05f2-d849-40c8-9fc9-80449c196070/attachments/71b336acd64a487ea8f6710e443d86c9_FullColor_TransparentBg_1280x1024_72dpi.png";

const HERO_IMG =
  "https://images.unsplash.com/photo-1718220268527-4477fd170775?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxiaW9waGlsaWMlMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3NzkwOTUxNzN8MA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden bg-[#F9F8F6] grain"
    >
      {/* Asymmetric split layout */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 pt-32 sm:pt-40 pb-20 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end min-h-[100svh]">
        {/* Left: text */}
        <div className="lg:col-span-7 fade-up">
          <h1 className="font-[Outfit] font-extralight tracking-[-0.02em] leading-[0.95] text-[#2D332B] text-[44px] sm:text-[68px] lg:text-[92px]">
            Living interiors,
            <br />
            <span className="italic font-light text-[#8A9A86]">
              quietly composed.
            </span>
          </h1>

          <p className="mt-10 max-w-xl text-[15px] sm:text-[17px] leading-relaxed text-[#5C6658]">
            Indoor Greens is the luxury biophilic design &amp; maintenance
            partner for commercial and residential spaces. We
            curate plant architecture that breathes alongside its
            inhabitants.
          </p>

          <div className="mt-12 flex flex-wrap items-center gap-6">
            <a
              href="#contact"
              data-testid="hero-cta-primary"
              className="inline-flex items-center px-7 py-3.5 bg-[#2D332B] text-[#F9F8F6] text-[12px] tracking-[0.25em] uppercase hover:bg-[#8A9A86] transition-colors duration-500 rounded-sm"
            >
              Begin a project
            </a>
            <a
              href="#bonsai"
              data-testid="hero-cta-secondary"
              className="link-underline text-[12px] tracking-[0.25em] uppercase text-[#2D332B]"
            >
              Explore Bombay Bonsai
            </a>
          </div>
        </div>

        {/* Right: image + floating logo card */}
        <div className="lg:col-span-5 relative w-full">
          <div className="relative aspect-[4/5] w-full overflow-hidden rounded-sm">
            <img
              src={HERO_IMG}
              alt="Biophilic interior"
              className="w-full h-full object-cover"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#2D332B]/20 via-transparent to-transparent" />
          </div>

          {/* Logo card overlapping bottom-left of image */}
          <div className="absolute -bottom-8 -left-6 sm:-left-10 bg-[#F9F8F6] border border-[#E5E1DB] px-8 py-6 shadow-[0_18px_60px_-20px_rgba(45,51,43,0.18)] rounded-sm flex items-center gap-4">
            <img
              src={LOGO}
              alt="Indoor Greens"
              className="h-14 w-auto object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
